import {
    messageContainer as messageContainerBase, messageTime as messageTimeBase, speechBubble as speechBubbleBase,
    speechBubbleContainer as speechBubbleContainerBase,
} from '../../ChannelMessage/styles/ChannelMessage'

export const messageContainer = {
    ...messageContainerBase,
    flexBasis: '800px',
    variants: {
        hidden: {true: {opacity: '.25'}},
        me: {
            true: {
                '.compact &': {flexDirection: 'row' as const},
                'flexDirection': 'row-reverse' as const,
            },
        },
        repeated: {true: {marginTop: 0}},
    },
}

export const speechBubbleContainer = {
    ...speechBubbleContainerBase,
    width: '100%',
}

export const speechBubble = {
    ...speechBubbleBase,
    boxSizing: 'border-box',
    width: '100%',
}

export const invitationWrapper = {
    padding: '5px 0 20px',
    position: 'relative',
    width: '100%',
}

export const invitationHighlighted = {
    background: '$messageInvitationHighlighted',
    borderRadius: '$messageInvitationHighlighted',
    boxSizing: 'border-box',
    margin: '0 0 $messageInvitationHighlightedVertical',
    padding: '$messageInvitationHighlightedPadding',
    width: '100%',
}

export const channelInfoButton = {
    background: 'none',
    border: 'none',
    color: 'inherit',
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    fontSize: '$messageInvitationChannel',
    margin: '$messageInvitationInfoButtonVertical 0',
    padding: '$messageInvitationInfoButtonVertical 0 0',
}

export const realmName = {
    color: '$messageInvitationLightText',
    fontSize: '$messageInvitationRealm',
}

export const channelName = {
    alignItems: 'flex-start',
    display: 'flex',
    gap: '10px',
    marginBottom: '$messageInvitationChannelNameVertical',
    textAlign: 'left',
}

export const messageTime = {
    ...messageTimeBase,
    bottom: '5px',
    position: 'absolute',
    right: 0,
}

export const messageText = {marginBottom: '$messageInvitationTextVertical'}

export const buttonWrapper = {'&& button > svg': {color: '$success'}}
